export default "__VITE_ASSET__fc0c22d8__"